<template>
  <section class="flex justify-between bg-bg-common-color overflow-hidden">
    <div class="pt-4 pb-5 px-4 box-border flex-1 flex flex-col overflow-hidden">
      <header class="h-24 mb-4 bg-white shadow-theme rounded-medium">
        <undertake-statistics :statement-id="statementId" />
      </header>
      <div class="flex-1 px-4 pt-4 box-border bg-white overflow-hidden">
        <data-table
          ref="dataTable"
          class="sms_table w-full h-full overflow-hidden"
          cell-class-name="truncate-table-cell-wrap"
          align="left"
          :height="list.length > 0 ? 'calc(100% - 48px)' : '100%'"
          :data="list"
          :loading="tableLoading"
          :columns="columns"
          :show-page="list.length > 0"
          :page="page"
          :show-tooltip="true"
          @size-change="changeSize"
          @pagination-current-change="changeNum"
        >
          <template #projectCategory="{ row }">
            <span>{{ projectCategoryMap[row.projectCategory] || '—' }}</span>
          </template>
          <template #taskName="{ row }">
            <span>{{ row.taskName || '—' }}</span>
          </template>
          <template #investigateTime="{ row }">
            <span v-if="row.investigateStartTime">{{ row.investigateStartTime }}至{{ row.investigateEndTime }}</span>
            <span v-else>—</span>
          </template>
          <template #settleMode="{ row }">
            <span>{{ settleModeMap[row.settleMode] || '—' }}</span>
          </template>
          <template #unitQuantity="{ row }">
            <span>{{ getUnitQuantityText(row) }}</span>
          </template>
          <template #unitPriceYuan="{ row }">
            <span>{{ getUnitPriceYuan(row) }}</span>
          </template>
          <template #operationalYuanAmountForAll="{ row }">
            <span>{{ row.operationalYuanAmountForAll | formatPrice }}</span>
          </template>
          <template #action="{ row }">
            <el-button type="text" @click="toDetail(row)">查看</el-button>
          </template>
        </data-table>
      </div>
    </div>
    <aside class="bg-white w-290px overflow-auto">
      <undertake-process :invest-sid="investigatorStatementId" :refresh.sync="isRefresh" />
    </aside>
    <check-detail-drawer ref="checkDetail" :rows="rowDetail" @finished-remove="finishedRemove" />
  </section>
</template>

<script>
import DataTable from '@/components/base/DataTable'
import CheckDetailDrawer from '@/views/home/cost-settlement/settlement-initiate/settle-process/components/CheckDetailDrawer'
import UndertakeStatistics from './components/UndertakeStatistics'
import UndertakeProcess from '../components/UndertakeProcess'
import { pageMixins } from '@/mixins/publish'
import { filtersMixins } from '@/mixins/relate-settlement'
import { getUndertakeDetailList } from '@/api/cost-settlement/undertake'
import { getSettleDetailListById } from '@/api/cost-settlement/settlement-initiate/submitStatement'
import { PROJECT_CATEGORY } from '@/views/home/cost-settlement/settlement-initiate/settle-process/settleConst'
import { undertakeDetailColumns, projectCategoryMap, settleModeCode, settleModeMap } from '../config/undertake'

export default {
  name: 'UndertakeDetail',
  mixins: [pageMixins, filtersMixins],
  components: {
    DataTable,
    UndertakeStatistics,
    UndertakeProcess,
    CheckDetailDrawer
  },
  data() {
    return {
      projectCategoryMap,
      settleModeMap,
      columns: undertakeDetailColumns,
      list: [],
      tableLoading: false,
      isRefresh: false,
      rowDetail: {}
    }
  },
  computed: {
    investigatorStatementId() {
      return this.$route.query.investigatorStatementId ?? ''
    },
    statementId() {
      return this.$route.query.statementId ?? ''
    }
  },
  mounted() {
    this.searchList()
  },
  methods: {
    getUnitByMode(settleMode) {
      if ([settleModeCode.TASK, settleModeCode.QUESTION, settleModeCode.LADDER].includes(settleMode)) {
        return '份'
      } else if (settleModeCode.DAY === settleMode) {
        return '天'
      } else if (settleModeCode.POINT === settleMode) {
        return '点位'
      }
      return ''
    },
    getUnitQuantityText(item) {
      const { unitQuantity, settleMode } = item
      const uQuantity = unitQuantity ?? 0
      const unit = this.getUnitByMode(settleMode)
      return `${uQuantity}${unit}`
    },
    getUnitPriceYuan(item) {
      const unit = this.getUnitByMode(item.settleMode)
      const min = filtersMixins.filters.formatPrice(item.minUnitPriceYuan ?? 0)
      if (settleModeCode.LADDER === item.settleMode) {
        const max = filtersMixins.filters.formatPrice(item.maxUnitPriceYuan ?? 0)
        return `${min}~${max} 元/${unit}`
      }
      return `${min} 元/${unit}`
    },
    getList() {
      this.tableLoading = true
      const investigatorStatementId = this.investigatorStatementId ?? ''
      const params = {
        investigatorStatementId
      }
      const data = {
        investigatorStatementId
      }
      getUndertakeDetailList(params, data)
        .then(res => {
          const { total, records, current, size } = res?.data?.data || {}
          this.list = records || []
          this.page.total = total ?? 0
          this.page.currentPage = current
          this.page.pageSize = size
          this.$nextTick(()=>{
            this.$refs.dataTable.scrollTop()
          })
        })
        .catch(() => {
          this.$message.error('获取结算单明细失败')
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    toDetail(item) {
      this.rowDetail = item
      this.tableLoading = true
      getSettleDetailListById({ id: item.investigatorStatementId })
        .then(res => {
          const { SettleInvestigatorDetailList } = res?.data?.data || {}
          const childDetail = Array.isArray(SettleInvestigatorDetailList) ? SettleInvestigatorDetailList[0] ?? {} : {}
          const { id, projectCategory, settleMode, projectId, investigatorPhone } = childDetail
          const childDetailId = projectCategory === PROJECT_CATEGORY.MANUAL_IMPORT ? projectId : id
          this.$refs.checkDetail.open(
            item.investigatorStatementId,
            childDetailId,
            projectCategory,
            settleMode,
            projectId,
            investigatorPhone,
            item.status
          )
        })
        .catch(() => {
          this.$message.error('获取详情数据失败')
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    finishedRemove() {
      this.searchList()
      this.isRefresh = true
    }
  }
}
</script>
